import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { DomainList } from "./list";
import { DomainDetailRoute } from "./detailRoute";
import { DomainDraft } from "./create/draft";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const DomainRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<DomainList />} />
        <Route path={`-draft/*`} element={<DomainDraft />} />
        <Route path={`:domain/*`} element={<DomainDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default DomainRoute;
